module.exports = __webpack_public_path__ + "static/cashew_nuts_vuon_2-1f719898da3ab099e4ec77b37aa3cb2e.jpg";